import NotebookViewController from './NotebookViewController';
import { useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import {
  NotebookTabs,
  NotebookViews,
  TaskCategories,
} from '../../interfaces/notebook';
import { NotebookStore } from '../../stores/notebookStore/types';
import { shallow } from 'zustand/shallow';
import useNotebookStore from '../../stores/notebookStore';
import useHistoryWrapper from '../../hooks/useHistoryWrapper';
import { userActivitiesStore } from '../../stores/userActivitiesStore';

const notebookPageSelector = (state: NotebookStore) => ({
  setAutofocusTask: state.setAutofocusTask,
  toggleCurrentView: state.toggleCurrentView,
});
const NotebookController = () => {
  const history = useHistoryWrapper();
  const currentLocation = useLocation();

  const { setAutofocusTask, toggleCurrentView } = useNotebookStore(
    notebookPageSelector,
    shallow,
  );

  const hasTabView = useMemo(
    () =>
      currentLocation.pathname.includes(NotebookTabs.myWork) ||
      currentLocation.pathname.includes(NotebookTabs.ato),
    [currentLocation.pathname],
  );

  const params = useMemo(
    () => (!isEmpty(currentLocation.search) ? currentLocation.search : ''),
    [currentLocation.search],
  );

  const { upsertUserActivity } = userActivitiesStore.getState();

  useEffect(() => {
    upsertUserActivity({
      visitCount: 1,
      type: 'notebook',
      pageTitle: `Notebook - My Tasks`,
      url: `${currentLocation.pathname}`,
      lastVisitedAt: new Date().toISOString(),
      pageDescription: `Manage all tasks assigned to you and created by you`,
    });
  }, [currentLocation.pathname, upsertUserActivity]);

  useEffect(() => {
    const currentViewName = currentLocation.pathname.includes(
      NotebookViews.Board,
    )
      ? NotebookViews.Board
      : NotebookViews.Deadline;
    toggleCurrentView(currentViewName);
    if (
      currentViewName === NotebookViews.Deadline &&
      currentLocation.search.includes('createTask=true')
    ) {
      setAutofocusTask(TaskCategories.TODAY);
    }
  }, [currentLocation, setAutofocusTask, toggleCurrentView]);

  useEffect(() => {
    if (hasTabView) {
      history.push(`/notebook/${NotebookViews.Deadline}${params}`);
    }
  }, [hasTabView, history, params]);

  return <NotebookViewController />;
};

export default NotebookController;
